import {
  faChevronDown,
  faDiagramProject,
  faEarthAmericas,
  faHandshakeSimple,
  faHome,
  faListCheck,
  faMagnifyingGlassChart,
  faSearch,
  faSeedling,
  faVideo,
  IconDefinition,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useFetchProgramas } from "../../hooks/useFetchProgramas";
import { getListaRepresentaciones } from "../../api/representation";
import { getListaProgramas } from "../../api/programas";
import { IRepresentacion } from "../../interfaces/Representacion";
import { IProgramas } from "../../interfaces/Programas";

const SimpleSidebarItem: React.FC<{
  text: string;
  link: string;
  target?: string;
  icon: IconDefinition;
}> = ({ text, link, icon, target = "_self" }) => {
  return (
    <li className="nav-item">
      <Link className="nav-link collapsed" to={link} target={target}>
        <i>
          <FontAwesomeIcon icon={icon} />
        </i>
        <span>{text}</span>
      </Link>
    </li>
  );
};

const CollapsibleSidebarItem: React.FC<{
  text: string;
  icon: IconDefinition;
  children: any;
}> = ({ text, icon, children }) => {
  const link = useRef<HTMLButtonElement>(null);
  const content = useRef<HTMLUListElement>(null);

  const toggleMenu = () => {
    var refLink = link.current;
    var refContent = content.current;

    if (refLink) {
      if (refLink.classList.contains("collapsed")) {
        refLink.classList.remove("collapsed");
      } else {
        refLink.classList.add("collapsed");
      }
    }

    if (refContent) {
      if (refContent.classList.contains("show")) {
        refContent.classList.remove("show");
      } else {
        refContent.classList.add("show");
      }
    }
    return;
  };

  return (
    <li className="nav-item">
      <button
        ref={link}
        onClick={() => toggleMenu()}
        style={{ width: "100%" }}
        className="btn btn-link nav-link collapsed"
      >
        <i>
          <FontAwesomeIcon icon={icon} />
        </i>{" "}
        <span>{text}</span>{" "}
        <i className="ms-auto chevron-down">
          <FontAwesomeIcon icon={faChevronDown} />
        </i>
      </button>
      <ul ref={content} className="nav-content collapse">
        {children}
      </ul>
    </li>
  );
};

const CollapseItem: React.FC<{
  text: string;
  link: string;
  target?: string;
}> = ({ text, link, target = "_self" }) => {
  return (
    <li>
      <Link to={link} target={target}>
        {text}
      </Link>
    </li>
  );
};

const Sidebar = () => {
  const { t, i18n } = useTranslation("translation", { keyPrefix: "layout.sidebar" });

  const [representation, setRepresentation] = useState<IRepresentacion[]>()
  const [programs, setProgramas] = useState<IProgramas[]>()
  
  useEffect(() => {
    getListaRepresentaciones(i18n.language)
    .then((res) => {
      setRepresentation(res)
    })
    getListaProgramas(i18n.language)
    .then((res) => {
      setProgramas(res)
    })
  }, [i18n.language])

  if(!representation || !programs) {
    return null
  }

  return (
    <aside id="sidebar" className="sidebar">
      <ul className="sidebar-nav" id="sidebar-nav">        
        <SimpleSidebarItem text={t("inicio")} link="/" icon={faHome} />
        <SimpleSidebarItem text={t("video")} link={t("video_url")} target="_blank" icon={faVideo} />
        <SimpleSidebarItem text={t("numeros")} link="/iica-numeros" icon={faMagnifyingGlassChart} />
        <SimpleSidebarItem text={t("opsaa")} link="/opsaa" icon={faSearch} />
        <SimpleSidebarItem text={t("resultados")} link="/iniciativas/palabras-clave" icon={faSeedling} />
        <SimpleSidebarItem text={t("alianzas")} link="/iniciativas/contrapartes" icon={faHandshakeSimple} />    
        <SimpleSidebarItem text={t("regionales")} link="/iniciativas/regionales" icon={faDiagramProject} />
        <CollapsibleSidebarItem text={t("paises")} icon={faEarthAmericas}>
          {representation.map((value, key) => {
            return (
              <CollapseItem
                key={key}
                text={value.pais}
                link={`/iica-numeros/${value.codigo_Unidad}`}
              ></CollapseItem>
            );
          })}
        </CollapsibleSidebarItem>
        <CollapsibleSidebarItem text={t("programas")} icon={faListCheck}>
          {programs.map((value, key) => {
            return (
              <CollapseItem
                key={key}
                text={value.programa}
                link={`/program/${value.codPrograma}`}
              ></CollapseItem>
            );
          })}
        </CollapsibleSidebarItem>
      </ul>
    </aside>
  );
};

export default Sidebar;
